import React from 'react';
import { ExternalLink } from 'Common/Links/ExternalLink';
import SesamLink from 'Common/Links/SesamLink';
import CenteredLayout from '../layout/centered';
import { Links } from 'Constants/links';

import './server-error.css';
import { TestID } from 'src/testID';

export const ServerErrorPage = () => (
  <CenteredLayout>
    <main>
      <h2 className="server-error-title" data-testid={TestID.ServerErrorPageTitle}>
        Server error
      </h2>
      <section className="server-error-page-text">
        Uh-oh. Something unexpected just happened!
        <p>
          Please{' '}
          <SesamLink to="/" testId={TestID.TryReloadSiteAgainLink}>
            try again
          </SesamLink>{' '}
          in about 30 seconds.
        </p>
        <p>
          If the issue persists, try using our{' '}
          <ExternalLink href={Links.FallbackPortalUrl} testId={TestID.FallbackPortalLink}>
            fallback portal
          </ExternalLink>
          , available as a temporary read-only option.
        </p>
        If you continue to experience problems, contact us at{' '}
        <ExternalLink
          href={Links.MailToInfoAtSesamDotIO}
          testId={TestID.MailToInfoAtSesamDotIOLink}
        >
          info@sesam.io
        </ExternalLink>
        .
      </section>
    </main>
  </CenteredLayout>
);
